export function fragmentEncode(text: string): string {
    const replacedText = text.replace(/ /g, '-');
    return encodeURIComponent(replacedText.toLowerCase());
}
